import React from 'react'

const AudioPlayer = ({ src }) => {
  if (!src || src == 'null' || src == null) {
    // If src is null, undefined, or an empty string, this will return null, effectively rendering nothing
    return null
  }

  return (
    <audio controls controlsList="nodownload">
      <source src={src} type="audio/mpeg" />
      抱歉... 你的浏览器不支持声音控件
    </audio>
  )
}

export default AudioPlayer
